import type { QbotApiError } from '@/types/qbot';

function isQbotApiError(err: unknown): err is QbotApiError {
  return typeof err === 'object' && err !== null && 'data' in err;
}

/**
 * Map a `POST /decks/saved` failure to a `cr` locale key.
 *
 * The 50-deck cap is the awkward one: QBot answers 409 but reuses the generic
 * `INVALID_INPUT` code for it, so the code alone can't tell "you're full" from
 * "that deck is malformed". The HTTP status is what separates them.
 */
export function saveDeckErrorKey(err: unknown): string {
  if (!isQbotApiError(err)) return 'panel.save.error.generic';
  if (err.status === 409) return 'panel.save.error.limit';

  const code = err.data?.error?.code;
  if (code === 'INVALID_DECK') return 'panel.save.error.invalidDeck';
  if (code === 'NOT_LINKED') return 'panel.save.error.notLinked';
  return 'panel.save.error.generic';
}
